module.exports = __webpack_public_path__ + "media/assets/images/flags/lc-3a662dda9beafb9793fc7db95c8f3713.svg";